<template>
  <section id="uk-power-network-services" class="o-section c-services" v-my-section-class>

    <!-- Background -->
    <div class="o-background" v-if="$store.state.device !== 0">
      <div class="o-background__inner">
        <transition name="quick-fade">
          <div class="o-background__group o-background__group--circle" key="circle" v-if="tabIndex === 4">
            <my-circle class="o-background__item o-background__item--1" :image-file="'people/case-study'" :variant="2"></my-circle>
            <my-circle class="o-background__item o-background__item--2" :image-file="'people/case-study-2'"></my-circle>
          </div>
          <div class="o-background__group o-background__group--default" key="default" v-else></div>
        </transition>
      </div>
    </div>

    <!-- Content -->
    <div class="o-section__container">
      <h2 class="o-section__title">UK Power Networks Services</h2>

      <my-tabs @tab-changed="setTabIndex">

        <!-- Tab 1 -->
        <my-tab title="Services" :is-active="true">
          <my-tab-inner>
            <div class="o-panel__header">
              <h3 class="o-panel__title">Delivering safe, sustainable and profitable networks</h3>
            </div>
            <div class="o-panel__body o-panel__body--full">
              <div class="o-grid o-grid--2">
                <div class="o-grid__item">
                  <figure>
                    <img :src="require('@/assets/images/services.png')" :srcset="require('@/assets/images/services.png') + ' 1x, ' + require('@/assets/images/services@2x.png') + ' 2x'" width="512" height="220" alt="Diagram">
                  </figure>
                </div>
                <div class="o-grid__item">
                  <p>UK Power Networks also provides services on a competitive, commercial basis for clients running major national infrastructure projects and managing their own private energy networks. This is delivered by our affiliate company called UK Power Networks Services. We develop, deliver and manage safe, sustainable networks delivering high voltage electricity and multiple utilities for major national clients.</p>
                </div>
              </div>
            </div>

            <div class="o-link__btn-group">
              <my-download-button :section="'uk-power-network-services'"></my-download-button>
            </div>
          </my-tab-inner>
        </my-tab>

        <!-- Tab 2 -->
        <my-tab title="Achievements">
          <my-tab-inner>
            <div class="o-panel__header">
              <h3 class="o-panel__title">Achievements</h3>
            </div>
            <div class="o-panel__body o-panel__body--full">
              <div class="o-grid o-grid--3 o-grid--limit">
                <div class="o-grid__item">
                  <div class="o-award o-award--achieve">
                    <figure class="o-award__image">
                      <img :src="require('@/assets/images/logos/heathrow.png')" :srcset="require('@/assets/images/logos/heathrow.png') + ' 1x, ' + require('@/assets/images/logos/heathrow@2x.png') + ' 2x'" width="256" height="192" alt="Diagram">
                    </figure>
                  </div>

                  <h4>RACE THE PLANE WITH HEATHROW AIRPORT</h4>
                  <p>We helped Heathrow raise more than £100,000 for the charity Oxfam by racing an aircraft in real time 3,452 miles across the Atlantic from John F Kennedy International to Heathrow.</p>
                </div>

                <div class="o-grid__item">
                  <div class="o-award o-award--achieve">
                    <figure class="o-award__image">
                      <img :src="require('@/assets/images/logos/network-rail.png')" :srcset="require('@/assets/images/logos/network-rail.png') + ' 1x, ' + require('@/assets/images/logos/network-rail@2x.png') + ' 2x'" width="256" height="192" alt="Diagram">
                    </figure>
                  </div>
                  <h4>WE WON A NETWORK RAIL SUSTAINABLE CONSTRUCTION AWARD</h4>
                  <p>for our work to design and construct 33 substations as part of the Great Western mainline electrification project from London to Cardiff.</p>
                </div>
                <div class="o-grid__item">
                  <div class="o-award o-award--achieve">
                    <figure class="o-award__image">
                      <img :src="require('@/assets/images/logos/underground.png')" :srcset="require('@/assets/images/logos/underground.png') + ' 1x, ' + require('@/assets/images/logos/underground@2x.png') + ' 2x'" width="256" height="192" alt="Diagram">
                    </figure>
                  </div>
                  <h4>WE RECEIVED A BEACON AWARD FROM LONDON UNDERGROUND</h4>
                  <p>for outstanding performance on health, safety and environment at Stockwell during work on the Northern Line Extension.</p>
                </div>
              </div>
            </div>
          </my-tab-inner>
        </my-tab>

        <!-- Tab 2 -->
        <my-tab title="Clients">
          <my-tab-inner>
            <div class="o-panel__header">
              <h3 class="o-panel__title">Clients</h3>
              <p class="o-panel__subtitle">Our portfolio includes a range of high profile organisations from both the public and private sectors, including all four of London’s airports, High Speed 1, Network Rail, London Underground, Southern Water, Aspire and Canary Wharf.</p>
            </div>
            <div class="o-panel__body o-panel__body--full">
              <div class="o-grid o-grid--4 o-grid--thin">
                <div class="o-grid__item o-award" v-for="(item, index) in clients">
                  <figure class="o-award__image">
                    <img :src="require('@/assets/images/logos/' + item + '.png')" :srcset="require('@/assets/images/logos/' + item + '.png') + ' 1x, ' + require('@/assets/images/logos/' + item + '@2x.png') + ' 2x'" width="256" height="192" :alt="item">
                  </figure>
                </div>
              </div>
            </div>
          </my-tab-inner>
        </my-tab>

        <!-- Tab 3 -->
        <my-tab title="Accreditations">
          <my-tab-inner>
            <div class="o-panel__header">
              <h3 class="o-panel__title">Accreditations</h3>
              <p class="o-panel__subtitle">Our accreditations reflect our world class engineering capability, safety and quality record.</p>
            </div>
            <div class="o-panel__body o-panel__body--full">
              <div class="o-grid o-grid--4 o-grid--thin">
                <div class="o-grid__item o-award" v-for="(item, index) in accredit">
                  <figure class="o-award__image">
                    <img :src="require('@/assets/images/logos/' + item + '.png')" :srcset="require('@/assets/images/logos/' + item + '.png') + ' 1x, ' + require('@/assets/images/logos/' + item + '@2x.png') + ' 2x'" width="256" height="192" :alt="item">
                  </figure>
                </div>
              </div>
            </div>
          </my-tab-inner>
        </my-tab>

        <!-- Tab 4 -->
        <my-tab title="Case study">
          <my-tab-inner>
            <div class="o-panel__header">
              <h3 class="o-panel__title">Delivering sustainable construction</h3>
            </div>
            <div class="o-panel__body o-panel__body--full">
              <div class="o-grid o-grid--2 o-media--2">
                <div class="o-grid__item">
                  <p>UK Power Networks Services won the Sustainable Construction Award at Network Rail’s Great Western ‘World Environment Day’ for work electrifying sections of the Great Western Mainline route that runs from London to Cardiff.</p>

                  <p>We won the award for the revolutionary and innovative use of macro synthetic fibre in place of traditional steel reinforcement for construction of load bearing concrete structures. The fibre was added to the concrete at source, so it was not necessary to construct the steel frames on site, thus avoiding several safety hazards and environmental risks.</p>

                  <p>This product eliminated both manual handling and working from height on site, instantly lowering the risk of injury. The environmental benefits included a 42 tonne reduction of reinforcing steel going to site and reduction of embodied carbon by 18,000kg CO<sub>2</sub> equivalent.</p>
                </div>
                <div class="o-grid__item">
                  <div class="o-kpi">
                    <h4 class="o-kpi__figure">18,000 kg CO<sub>2</sub></h4>
                    <p class="o-kpi__caption">Reduction of embodied carbon equivalent</p>
                  </div>
                  <div class="o-kpi">
                    <h4 class="o-kpi__figure">42 tonnes</h4>
                    <p class="o-kpi__caption">Reduction of reinforcing steel</p>
                  </div>
                </div>
              </div>

            </div>
          </my-tab-inner>
        </my-tab>
      </my-tabs>
    </div>
  </section>
</template>

<script>
import { MySectionClass } from '@/directives/my-section-class.js'
import { MyTabs, MyTab, MyTabInner } from '@/components/standard/my-tabs'
import MyDownloadButton from '@/components/standard/my-download-button'
import MyTable from '@/components/standard/my-table'
import MyCircle from '@/components/standard/my-circle'
import mixins from '@/mixins'

export default {
  name: 'my-services',
  components: {
    MyTabs,
    MyTab,
    MyTabInner,
    MyCircle,
    MyTable,
    MyDownloadButton
  },
  data () {
    return {
      clients: [
        'heathrow',
        'gatwick',
        'london-city',
        'stansted',
        'canary-wharf',
        'high-speed',
        'network-rail',
        'underground',
        'aspire',
        'southern-water',
        'tarmac'
      ],
      accredit: [
        'kite',
        'chas',
        'ciras',
        'fors',
        'lloyds',
        'constructionline',
        'dnvgl',
        'risqs',
        'uvdb'
      ]
    }
  },
  directives: {
    MySectionClass
  },
  mixins: [mixins]
}
</script>



// WEBPACK FOOTER //
// MyServices.vue?bd8c9e30